var path = 'src/app/posts/latest-posts.html';
var html = "<h2>Latest News</h2> <div loading=loading> <div ng-show=!items.length> <p>No posts found.</p> </div> <div ng-repeat=\"item in items\" class=post> <h3><a ui-sref=\"post({postId: item.id})\">{{item.title}}</a> <small>{{item.publishedDate | dateFormat}}</small></h3> <div ng-bind-html=\"item.body | unsafe\"></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/posts/latest-posts.html
 ** module id = 637
 ** module chunks = 0
 **/